<template>

    <fieldset class="o-grid o-grid-12" v-if="!disabledIDs.includes(field.id)">
    
        <div class="o-grid-12" v-if="sectionTitle && String(sectionTitle).trim()!=''">
            <h2 class="o-title-3" v-html="sectionTitle"></h2>
        </div>


        <div class="o-grid-12" v-if="field.groupIsRepeater && field.groupIsRepeater === true">
            <div class="o-grid o-grid-12 -repeater-item o-form__repeater__item" v-for="(fieldsList, ri) in field.fieldsList">
                <div class="o-grid-12 -repeater-item__header o-form__repeater__header">
                    <h4 class="o-title-4" style="margin-bottom:0;">{{ field.repeaterItemsLabel }} {{ ri+1 }}</h4>
                    <button type="button" class="o-form__repeater__header__button" @click="field.fieldsList.splice(ri, 1)" v-if="field.fieldsList.length > repeaterMinlength">
                        <svgIco icon="bin" class="o-form__repeater__header__button__icon" />
                    </button>
                </div>
                <component
                    v-for="(fieldd, fi) in fieldsList"
                    :key="fieldd.id + '-' +fieldd.repeaterIndex"
                    :is="fieldd.inputType"
                    :field="fieldd"
                    :disabledIDs="disabledIDs"
                    class="o-form__item__wrap"
                    :repeaterIndex="fieldd.repeaterIndex"
                />
            </div>
        </div>

        <div class="o-grid-12" v-if="field.groupIsRepeater && field.groupIsRepeater === true && repeaterMinlength != repeaterMaxlength">
            <button class="o-button -button-md" type="button" @click="addItem"
                :disabled="(repeaterMaxlength && repeaterMaxlength > 0 && repeaterMaxlength < field.fieldsList.length + 1) ? 'disabled' : false">
                <svgIco icon="add" class="o-button__icon" />
                <span v-html="field.repeaterButtonLabel"></span>
            </button>
        </div>

        <component
            v-else
            v-for="(fieldd, fi) in field.fieldsList"
            :key="fieldd.id"
            :is="fieldd.inputType"
            :field="fieldd"
            :disabledIDs="disabledIDs"
            class="o-form__item__wrap"
        />

    </fieldset>

</template>


<script>

export default {
    name: 'FieldsGroup',
    props: {
        field:{
            type: Object,
            default() {
                return {}
            },
        },
        disabledIDs:{
            type: Array,
            default() {
                return []
            },
        },
        sectionTitle:{
            type: String,
            default: null,
        },
    },
    data(){
        return {
            hasMaxDefined: false,
    	}
    },
    mounted() {
        if (!this.field.length || this.field.length < this.repeaterMinlength) {
            while (this.field.fieldsList.length < this.repeaterMinlength){
                this.addItem()
            }
        }
    },
    computed: {

        repeaterMinlength: function () {
            let repeaterMinlength = null
            this.hasMaxDefined = false
            if (this.field.repeaterMinlength) repeaterMinlength = this.field.repeaterMinlength
            if (this.field.repeaterItemslength && String(this.field.repeaterItemslength).trim() != '') {
                repeaterMinlength = this.field.repeaterItemslength
                this.hasMaxDefined = true
            }else if (this.field.repeaterItemslengthFromField && String(this.field.repeaterItemslengthFromField).trim() != '') {
                let refField = this.getFieldByID(this.field.repeaterItemslengthFromField)
                repeaterMinlength = (refField && refField.value !== null) ? refField.value : null
                this.hasMaxDefined = true
            }

            return repeaterMinlength
        },

        repeaterMaxlength: function () {
            let repeaterMaxlength = 30
            if (this.field.repeaterMaxlength) repeaterMaxlength = this.field.repeaterMaxlength
            if (this.hasMaxDefined) return this.repeaterMinlength

            if (this.repeaterMinlength > repeaterMaxlength) repeaterMaxlength = this.repeaterMinlength
            return repeaterMaxlength
        },

        lastRepeaterIndex: function () {
            indexes = []

            this.$root.form.sections.forEach(section => {
                section.fields.forEach(field => {
                    if (field.groupIsRepeater && field.groupIsRepeater === true) {
                        field.fieldsList.forEach(fieldsList => {
                            fieldsList.forEach(field => {
                                if (field.repeaterIndex) indexes.push(field.repeaterIndex)
                            })
                        })
                    }
                })
            })
            return (!indexes.length)? 0 : Math.max(...indexes)
        },
    },
    watch: {
        repeaterMinlength: function (val) {
            if (this.field.fieldsList.length < val) {
                while (this.field.fieldsList.length < val){
                    this.addItem()
                }
            }
            if (this.field.fieldsList.length > val) {
                this.field.fieldsList = this.field.fieldsList.slice(0, val)
            }
        },
    },
    methods: {
        addItem: function () {
            if (!this.field.initialFieldsList) return
            let fieldsList = JSON.parse(JSON.stringify(this.field.initialFieldsList))
            fieldsList.forEach(field => {
                field.repeaterIndex = this.lastRepeaterIndex + 1
                field.inputName = field.inputName + '[' + field.repeaterIndex + ']'
                field.id = field.id + '-' + field.repeaterIndex
            })
            this.field.fieldsList.push(fieldsList)
        },

        getFieldByID(fieldID) {

            let foundField = null

            this.$root.form.sections.forEach(section => {
                section.fields.forEach(fields => {
                    fields.fieldsList.forEach(field => {
                        if (field.id == fieldID) {
                            foundField = field
                        }
                    })
                })
            })

            return foundField
        },

    },
}

</script>